import { lazy } from "react";
import { Route, Switch } from "react-router-dom";

const QuickViewInlineExpansionPage = lazy(
  () =>
    import("@faire/prototype-playground/workspace/mb/quick-view-inline-expansion/Page")
);

export function MatthewBojeyRoutes() {
  return (
    <Switch>
      <Route
        path="/mb/quick-view-inline-expansion"
        component={QuickViewInlineExpansionPage}
      />
    </Switch>
  );
}

export const slug = "mb";
